import onetime from "@-/com.npmjs.onetime";
import { getPinyinSyllables } from "@-/dev.improve.haniverse.lib.morpheme.grapheme.pinyin";

/** Every non-empty prefix of a standard syllable. */
export const getPinyinSyllablePrefixSet = onetime(
  (): ReadonlySet<string> =>
    new Set(
      getPinyinSyllables().flatMap((syllable) =>
        Array.from({ length: syllable.length }, (_, index) => syllable.slice(0, index + 1)),
      ),
    ),
);
